import React from "react";
import "./App.css";
import SocialIcon from "./socialIcon.js";
import svgLinkedin from "./assets/svg/01-linkedin.svg";
import svgDribbble from "./assets/svg/01-dribbble.svg";
import svgGithub from "./assets/svg/01-github.svg";

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.294 6.779L14.571 0.5H13.3L8.728 5.955L5.143 0.5H0.5L6.04 8.836L0.5 15.5H1.771L6.604 9.748L10.357 15.5H15L9.294 6.779ZM7.24 8.986L6.68 8.164L2.24 1.47H4.52L7.737 6.292L8.297 7.114L13.3 14.56H11.02L7.24 8.986Z" fill="black"/>
  </svg>
);

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-text-container">
        <p>© 2026 Nick Hart</p>
      </div>
      <div className="social-container-footer justify-content-end row">
      <div className="socialIcon-container" style={{display:'inline-block', width:'auto', height:'20px', margin:'2px 8px'}}>
        <a href="https://x.com/NickDoesDesign" target="_blank" rel="noopener noreferrer">
          <XIcon />
        </a>
      </div>
      <SocialIcon
        link="https://www.linkedin.com/in/nick-hart-00/"
        image={svgLinkedin}
      />
      <SocialIcon
        link="http://www.dribbble.com/nickhart"
        image={svgDribbble}
      />
      <SocialIcon
        link="https://github.com/nickhart203/"
        image={svgGithub}
      />
    </div>
    </div>
  );
}

export default Footer;
